"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var _external = require("../../external");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    text = _ref.palette.text;
  return {
    root: {
      borderCollapse: 'collapse',
      width: '100%',
      marginBottom: 40,
      borderSpacing: 0,
      '& tr': {
        '&:hover': {
          backgroundColor: '#FCFCFC'
        }
      },
      '& th, & td': {
        borderBottom: "1px solid ".concat((0, _external.fade)('#C9C9C9', 0.3)),
        padding: '8px 6px',
        textAlign: 'left',
        '&:first-of-type': {
          paddingLeft: 0
        },
        '&:last-of-type': {
          paddingRight: 0
        }
      },
      '& th': {
        fontWeight: typography.fontWeightSemiBold,
        fontFamily: typography.fontFamily,
        textTransform: 'uppercase',
        color: text.primary,
        fontSize: '11px',
        lineHeight: 1.36,
        letterSpacing: '1.65px',
        paddingTop: 23,
        paddingBottom: 23
      },
      '& td': {
        color: text.primary,
        fontSize: '14px',
        lineHeight: 1.35,
        letterSpacing: 0,
        fontWeight: typography.fontWeightRegular,
        fontFamily: typography.fontFamily
      }
    }
  };
}, {
  name: 'Table'
});
exports.useStyles = useStyles;